import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { useAnalytics } from '@/hooks/analytics';

import {
  DropdownInput,
  Language,
} from '@/components/to-blokkie/dropdown-input/dropdown-input';

export function ChangeLanguageDropdown() {
  const { i18n } = useTranslation();
  const { trackEvent } = useAnalytics();
  const { campaignId, campaignType } = useParams();

  const languageLabel = (lang: Language) => {
    const icons = {
      nl: '🇳🇱',
      en: '🇬🇧',
      fr: '🇫🇷',
      de: '🇩🇪',
    };

    const flag = icons[lang];

    if (!flag) {
      return lang.toUpperCase();
    }

    return `${flag} ${lang.toUpperCase()}`;
  };

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    trackEvent('web_language_selector', {
      campaignType,
      campaignId,
      language: lang.toUpperCase(),
    });
  };

  return (
    <>
      <DropdownInput
        defaultValue={i18n.language as Language}
        onChange={handleLanguageChange}
        items={Object.keys(i18n.services.resourceStore.data).map((lang) => ({
          value: lang,
          label: languageLabel(lang as Language),
          lang: lang as Language,
        }))}
      />
    </>
  );
}
